import { render, staticRenderFns } from "./dropzone.vue?vue&type=template&id=5aaf7826&scoped=true"
import script from "./dropzone.vue?vue&type=script&lang=js"
export * from "./dropzone.vue?vue&type=script&lang=js"
import style0 from "./dropzone.vue?vue&type=style&index=0&id=5aaf7826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf7826",
  null
  
)

export default component.exports